import { styled } from 'styled-components';
import { Button, Typography, Utils } from 'team-hero-ui';

const { flexFn, pxToRem } = Utils;

export const SuccessWrapper = styled.div`
  padding: ${pxToRem([40, 20])};
  ${flexFn('center', 'center', 'column')};
  gap: ${pxToRem(20)};
  width: 100%;
  max-width: ${pxToRem(350)};
`;

export const DescriptionStyled = styled(Typography.Copy)`
  padding: ${pxToRem([10, 0])};
  font-size: ${pxToRem(14)};
`;

export const ButtonStyled = styled(Button)`
  &.MuiButton-root {
    width: 100%;
    height: ${pxToRem(44)};
  }
`;
